import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Button } from '../../../components/button'
import { useParams, Link } from "react-router-dom";
import WebhookForm from '../../../components/forms/webhook-form';
import { getWebhookDetail, getWebhookEvents } from '../../../slices/webhooks';

const WebhookEdit = () => {

    const {id} = useParams()
    const dispatch = useDispatch()
    const selectedWebhook = useSelector((state) => state.webhooks.selectedWebhook)
    const webhookEvents = useSelector((state) => state.webhooks.events)

    useEffect(() => {
        dispatch(getWebhookDetail(id))
    }, [id])

    useEffect(() => {
        dispatch(getWebhookEvents())
    }, [])

    const [showWebhook, setShowWebhook] = useState(false)

    useEffect(() => {
        if (selectedWebhook && selectedWebhook.id === parseInt(id)) {
            setShowWebhook(true)
        } else {
            setShowWebhook(false)
        }
    }, [selectedWebhook])

    return (
        <>
            <div className="container-fluid">
                <div className="row clamped">
                    <div className="col px-0 settings-header flex-wrap">
                        <h1 className="title">Breyta vefkrók</h1>
                        <Link to={"/settings/webhooks"}><Button variant={"secondary"} size={"sm"}>{gettext('Cancel')}</Button></Link>
                    </div>
                </div>
            </div>
            { showWebhook &&
                <WebhookForm webhook={selectedWebhook} events={webhookEvents}/>
            }
        </>
    )
}

export default WebhookEdit